import React from "react";
import {
	Link
} from "react-router-dom";
import config from './../config.js';
import Loading from './../../components/loading.js';
import Actionsheets from './../../components/actionsheets.js';
import Modal from './../../components/modal.js';
import Serviceparams from './project_service_params.js';
import {
	getparams
} from './common/params.js';

export default class ProjectImageList extends React.Component {
	constructor(props) {
		super(props);
		let user = {};


		if (typeof localStorage.token !== 'undefined' && localStorage.token !== '') {
			user = JSON.parse(localStorage.user);
		}

		this.state = {
			user: user,
			projectid: props.data.projectid,
			type: '',
			creator: '',
			loading: true,
			isaction: false,
			tasks: [],
			linkname: {},
			params: '',
			modal_title: '查看参数',
			ismodal: false,
			actiontaskid: ''
		}
		this.onInitial(props.data);
		this.modal_close = this.modal_close.bind(this);
		this.actionClose = this.actionClose.bind(this);
		this.actionSubmit = this.actionSubmit.bind(this);
		this.removeTask = this.removeTask.bind(this);
	}


	componentDidMount() {
		this.config_states(this.props);
	}


	componentWillReceiveProps(nextProps) {
		this.config_states(nextProps);
		this.onInitial(nextProps.data);
	}

	config_states(nProps) {
		let linkname = {
			qc1: '查看原图',
			qc2: '颅骨剥离图'
		};
		const type = nProps.data.type;
		const imageparams = JSON.stringify(getparams(type));
		if (type === 'tbss') {
			linkname = {
				qc1: '查看FA图',
				qc2: '查看QC图'
			}
		}
		this.setState({
			type: type,
			linkname: linkname,
			creator: nProps.creator,
			params: JSON.parse(imageparams)
		});
	}


	onInitial(data) {
		const me = this;
		const {
			projectid,
			creator,
			type
		} = data;
		const postdata = {
			userid: this.state.user.id,
			projectid: projectid,
			type: type,
			result: 'list', //list or qc1 or qc2
			request: 'query',
			Authorization: localStorage.token
		};
		fetch(config.host + '/project_service/index', {
			method: 'post',
			body: JSON.stringify(postdata)
		})
			.then(res => res.json())
			.then(json => {
				//console.log(json);
				if (json.status === 1) {
					me.setState({
						tasks: json.data,
						loading: false
					});
				} else {
					me.setState({
						tasks: [],
						loading: false
					});
				}
			})
			.catch(function (error) {
				console.log(error);
			});
	}


	actionClose() {
		this.setState({
			isaction: false,
			actiontaskid: ''
		})
	}


	actionSubmit(id) {
		this.setState({
			actiontaskid: id,
			isaction: true
		})
	}

	removeTask(id) {
		const me = this;
		let {
			projectid,
			type,
			tasks,
			actiontaskid
		} = me.state;
		const postdata = {
			userid: this.state.user.id,
			projectid: projectid,
			taskid: actiontaskid,
			type: type,
			request: 'remove',
			Authorization: localStorage.token
		};
		me.setState({
			loading: true
		});
		//console.log(postdata);
		fetch(config.host + '/project_service/index', {
			method: 'post',
			body: JSON.stringify(postdata)
		})
			.then(res => res.json())
			.then(json => {
				//console.log(json);
				if (json.status === 1) {
					tasks.map((t, i) => {
						if (t.id === actiontaskid) {
							tasks.splice(i, 1);
						}
						return t;
					});
					me.setState({
						tasks: tasks,
						loading: false,
						isaction: false,
						actiontaskid: ''
					});
				} else {
					me.setState({
						loading: false,
						isaction: false,
						actiontaskid: ''
					});
				}
			})
			.catch(function (error) {
				me.setState({
					loading: false
				});
				console.log(error);
			});
	}


	getParams(id) {
		const me = this;
		const creator = me.props.creator;
		let {
			projectid,
			type
		} = me.state;
		const postdata = {
			userid: this.state.user.id,
			projectid: projectid,
			taskid: id,
			type: type,
			createid: creator.id,
			request: 'params',
			Authorization: localStorage.token
		};
		me.setState({
			loading: true
		});
		//console.log(postdata);
		fetch(config.host + '/project_service/index', {
			method: 'post',
			body: JSON.stringify(postdata)
		})
			.then(res => res.json())
			.then(json => {
				//console.log(json);
				if (json.status === 1) {
					me.setState({
						loading: false
					});
					me.setCurrentParams(json.data);
				} else {
					me.setState({
						loading: false
					});
				}
			})
			.catch(function (error) {
				me.setState({
					loading: false
				});
				console.log(error);
			});
	}


	setInputThresh(n) {
		let m = String(1 - n);
		//console.log(m);
		const point = n.toString().split(".")[1].length;
		//console.log(point + m.indexOf("."));
		const result = m.substr(0, point + m.indexOf(".") + 1);
		//console.log(result);
		return result;
	}


	setCurrentParams(data) {
		const me = this;
		let {
			type,
			params
		} = me.state;
		if (type === 'vbm') {
			const {
				brain_template,
				report,
				skull_stripping,
				statistics
			} = data;
			let {
				input_thresh,
				template_index
			} = report;
			const {
				clusterbased_thresh,
				input_file,
				method,
				permutation_number
			} = statistics;
			input_thresh = me.setInputThresh(input_thresh);
			//console.log(input_thresh);
			params.forEach(p => {
				//console.log(p);
				if (p.content.type === 'list') {
					p.content.child.forEach(c => {
						c.defaultCheck = false;
						if (c.name === 'skull_stripping' && c.value === skull_stripping) c.defaultCheck = true;
						if (c.name === "brain_template" && c.value === brain_template) c.defaultCheck = true;
						if (c.name === "input_thresh" && c.value === input_thresh) c.defaultCheck = true;
						if (c.name === "template_index" && c.value === template_index) c.defaultCheck = true;
					});
				}
				if (p.content.type === 'tabs') {
					p.content.child.forEach(c => {
						c.defaultCheck = false;
						if (c.name === 'statistics_method' && c.value === method) {
							c.defaultCheck = true;
							c.tabcontent.forEach(tab => {
								if (typeof (tab.input) === 'undefined') {
									if (tab.name === 'permutation_number[' + method + ']') tab.value = permutation_number;
									if (tab.name === 'clusterbased_thresh[' + method + ']' && clusterbased_thresh !== 'undefined') tab.value = clusterbased_thresh;
								} else {
									tab.input.forEach(input => {
										input.defaultCheck = false;
										if (input.value === input_file) input.defaultCheck = true;
									})
								}
							});
						}
					})
				}
			});
		}

		if (type === 'tbss') {
			const {
				skeleton_map_template,
				report,
				skeleton_threshold,
				space_template,
				statistics
			} = data;
			let {
				input_thresh,
				template_index
			} = report;
			const {
				permutation_number
			} = statistics;
			input_thresh = me.setInputThresh(input_thresh);
			//console.log(params);
			//console.log(input_thresh);
			params.forEach(p => {
				//console.log(p);
				if (p.content.type === 'list') {
					p.content.child.forEach(c => {
						c.defaultCheck = false;
						if (c.name === "space_template" && c.value === space_template) c.defaultCheck = true;
						if (c.name === 'skeleton_map_template' && c.value === skeleton_map_template) c.defaultCheck = true;
						if (c.name === "skeleton_threshold") c.value = skeleton_threshold;
						if (c.name === "permutation_number") c.value = permutation_number;
						if (c.name === "input_thresh" && c.value === input_thresh) c.defaultCheck = true;
						if (c.name === "template_index" && c.value === template_index) c.defaultCheck = true;
					});
				}
			});
		}

		me.setState({
			ismodal: true,
			params: params
		})

	}


	modal_close() {
		const me = this;
		me.setState({
			ismodal: false
		});
	}


	render() {
		let tbody = null;
		if (this.state.tasks.length) {
			tbody = this.state.tasks.map((m, i) => {
				const links = {
					qc1: {
						pathname: '/console/myprojects/project/service_detail/' + m.project_id + '/' + m.id + '/' + m.type + '/qc1',
						state: { name: m.task_name }
					},
					qc2: {
						pathname: '/console/myprojects/project/service_detail/' + m.project_id + '/' + m.id + '/' + m.type + '/qc2',
					},
					qc3: {
						pathname: '/console/myprojects/project/service_result/' + m.project_id + '/' + m.id + '/' + m.type + '/result',
					}
				};
				return (<tr key={i} data-id={m.id} data-jsonpath={m.jsonpath}>
					<td>{m.task_name}</td>
					<td className="small">{m.date_created}</td>
					<td>
						{(() => {
							switch (m.status) {
								case '0':
									return (' 等待处理 ');

								case '1':
									return (<span className="text-success">处理完成</span>);

								case '2':
									return (' 处理失败 ');

								case '3':
									return (' 暂停处理 ');

								case '4':
									return (' 正在处理 ');

								default:
									break;
							}
						})()}
					</td>
					<td>
						{(() => {
							if (m.status === '1') {
								return (
									<span>
										<a href={m.download} className="mx-2 text-body"><small><i className="fa fa-download text-success"></i></small> 下载</a>
										<a className="mx-2 cursor" onClick={() => { this.getParams(m.id) }}> <small><i className="fa fa-gears text-success"></i></small> 配置参数</a>

										<span className="mx-2"><Link className="text-body" to={links.qc1}><i className="fa fa-image text-success"></i> {this.state.linkname.qc1}</Link></span>

										<span className="mx-2"><Link className="text-body" to={links.qc2}><i className="fa fa-adjust text-success"></i> {this.state.linkname.qc2}</Link></span>

										<span className="mx-2"><Link className="text-body" to={links.qc3}><i className="fa fa-arrows text-success"></i> 查看结果</Link></span>

									</span>
								)
							}
						})()}
						<span className="ml-2"><a className="text-danger remove" onClick={() => { this.actionSubmit(m.id) }}>删除</a></span>
					</td>
				</tr>)
			});
		}
		return (
			<div>
				<Loading display={this.state.loading} />
				<table className="table table-hover text-center">
					<thead className="thead-dark table-sm">
						<tr>
							<th>任务名称</th>
							<th>提交时间</th>
							<th>状态</th>
							<th>操作</th>
						</tr>
					</thead>
					<tbody>{tbody}</tbody>
				</table>

				<Modal title={this.state.modal_title} display={this.state.ismodal} close={this.modal_close} submit={this.modal_close}>
					<Serviceparams project={{ params: this.state.params }} />
				</Modal>

				<Actionsheets display={this.state.isaction}>
					<ul className="list-group text-center">
						<li className="list-group-item disabled">确定要删除?</li>
						<li className="list-group-item text-danger" onClick={this.removeTask}>删除</li>
						<li className="list-group-item" onClick={this.actionClose}>取消</li>
					</ul>
				</Actionsheets>
			</div>

		)
	}
}


// WEBPACK FOOTER //
// ./src/apps/console/project_image_list.js